import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="dialog"
export default class extends Controller {
  static targets = ['panel']

  static values = {
    open: { type: Boolean, default: false },
    name: String,
    restoreScroll: { type: Boolean, default: true }
  }

  static classes = ['width']

  connect() {
    this.nameValue ||= this.element.id
    window.ui.dialogs[this.nameValue] = this

    // el-dialog has built-in events: open, close, cancel
    // https://tailwindcss.com/plus/ui-blocks/documentation/dialog#el-dialog

    // Open is fired when the dialog is opened anyway but updating the open attr
    // this.element.addEventListener('open', () => console.log('open'))

    // Close fired when dialog is closed anyway but updating open attr
    this.element.addEventListener('close', () => this.handleClose())

    // Cancel fired when click outside or esc key. Close event then follows.
    // this.element.addEventListener('cancel', () => this.handleCancel())
  }

  openValueChanged(val, prevVal) {
    if (this.openValue) {
      this.open()
    } else {
      this.close()
    }
  }

  // Usually called from UiController
  open(event)  {
    // Change width if given
    if (event?.params?.width) {
      this.givenWidthCss = event.params.width.split(' ')

      this.panelTarget.classList.remove(...this.widthClasses)
      this.panelTarget.classList.add(...this.givenWidthCss)
    }

    this.element.show()
  }

  // Would be called from Stimulus action. Clicking the close button or outside
  // the modal will trigger the close event and handleClose()
  close(event) {
    this.element.hide()
    this.resetWidth()
  }

  resetWidth() {
    // Reset to original width
    if (this.givenWidthCss) {
      this.panelTarget.classList.remove(...this.givenWidthCss)
      this.panelTarget.classList.add(...this.widthClasses)
    }
  }

  /**
   * The built-in close event was fired
   * @param {*} event
   */
  handleClose(event) {
    this.resetWidth()
  }

  /**
   * The built-in cancel even was fired (clicking outside or hitting escape)
   * @param {*} event
   */
  handleCancel(event) {}

  show() { return this.open() }
  hide() { return this.close() }
}
